import type { PlaybookSectionNode } from "@repo/app-types/entities/playbook";
import { Size } from "@repo/ui/helpers/helpers";
import { Input } from "@repo/ui/Inputs/input";
import { Textarea, TextareaVariant } from "@repo/ui/Inputs/textarea";
import { Label } from "@repo/ui/Label/label";
import type { FC } from "react";
import { DiffableField } from "../diffableField.js";

export interface SectionFormProps {
  section: PlaybookSectionNode;
  liveSection?: PlaybookSectionNode;
  onUpdateSection: (updates: Partial<PlaybookSectionNode>) => void;
  isReadOnly?: boolean;
}

export const SectionForm: FC<SectionFormProps> = ({
  section,
  liveSection,
  onUpdateSection,
  isReadOnly = false,
}) => {
  const currentDescription = section.description ?? "";

  return (
    <div className="space-y-4">
      <div>
        <DiffableField
          label={<Label size={Size.SMALL}>Name</Label>}
          savedValue={liveSection?.name}
          value={section.name}
        >
          <Input
            value={section.name}
            onChange={(event) => {
              onUpdateSection({ name: event.target.value });
            }}
            placeholder="Introduction and compliance disclaimers"
            isDisabled={isReadOnly}
            maxLength={300}
          />
        </DiffableField>
      </div>

      <div>
        <DiffableField
          label={<Label size={Size.SMALL}>Description</Label>}
          savedValue={liveSection ? (liveSection.description ?? "") : undefined}
          value={currentDescription}
        >
          <Textarea
            value={currentDescription}
            onChange={(newValue) => {
              onUpdateSection({ description: newValue });
            }}
            placeholder="Describe this section..."
            variant={TextareaVariant.DEFAULT}
            className="w-full"
            isDisabled={isReadOnly}
            maxLength={2000}
          />
        </DiffableField>
        <p className="mt-2 text-sm text-gray-600">
          (Optional) This description helps the AI grader understand when to
          grade or skip this section.
        </p>
      </div>
    </div>
  );
};
